import { IllustrationName } from '@payfit/growth-platform-brand-system-v2/components/Picto/illustrationLibrary';

export type PlanIconProps = {
  name?: 'firstPayroll' | 'plan';
  index?: number;
};
export const getPlanIcon = ({
  name,
  index,
}: PlanIconProps): IllustrationName | undefined => {
  if (name === 'firstPayroll') {
    return 'plan_starter';
  }
  if (name === 'plan' && index !== undefined) {
    if(index === 0) return "plan_paie"
    if(index === 1) return "plan_paie_avancee"
    if(index === 2) return "plan_rhplus"
  }
  return;
};
